import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/home/r11/choice-graphics/src/components/home/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/home/r11/choice-graphics/src/components/home/how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioMosaic"] */ "/home/r11/choice-graphics/src/components/home/portfolio-mosaic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesSection"] */ "/home/r11/choice-graphics/src/components/home/services-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsCarousel"] */ "/home/r11/choice-graphics/src/components/home/testimonials-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBar"] */ "/home/r11/choice-graphics/src/components/home/trust-bar.tsx");
